module.exports = __webpack_public_path__ + "img/2025-0512-01-02.513f59ca.png";